import { useUser } from '@folklore/auth';
import { FormattedMessage } from 'react-intl';

import Blocks from '../../blocks/Blocks';
import PageTitle from '../../partials/PageTitle';

import styles from '../../../../styles/themes/iga/iga-tablee-account.module.css';

interface IgaTableeAccountProps {
    page: AccountPage;
}

function IgaTableePageAccount({ page }: IgaTableeAccountProps) {
    const { title, blocks } = page || {};

    const { draws } = useUser() || {};

    return (
        <div className={styles.container}>
            <PageTitle className={styles.pageTitle} title={title} />

            <div className={styles.section}>
                {draws.map(({ id, title, participationsCount }) => (
                    <div key={`draw-${id}`} className={styles.draw}>
                        <div className={styles.amount}>{participationsCount}</div>
                        <div className={styles.label}>
                            <FormattedMessage
                                defaultMessage="<strong>entries</strong> into the {draw} draw"
                                description="Draw card label"
                                values={{
                                    draw: title,
                                }}
                            />
                        </div>
                    </div>
                ))}
            </div>

            <Blocks blocks={blocks} isContainer className={styles.blocks} />
        </div>
    );
}

export default IgaTableePageAccount;
